import { render, staticRenderFns } from "./LabelNew.vue?vue&type=template&id=3415405a&"
import script from "./LabelNew.vue?vue&type=script&lang=ts&"
export * from "./LabelNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports